import { ArticleContent } from "article/ArticleContent";
import { GDPR } from "gdpr/GDPR";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const contentRoute: RouteObject = {
  path: "content",
  children: [{
    path: "enduserlicenceterms",
    loader: () => viewModel,
    Component: ArticleContent,
  }, {
    path: "securitypolicy",
    loader: () => viewModel,
    Component: ArticleContent,
  }, {
    path: "gdpr",
    loader: () => viewModel,
    Component: GDPR,
  }]
};